(function(window, undefined) {

    'use strict';



    var feat = {};


    var ua = navigator.userAgent.toLowerCase();

    feat.userAgent = ua;
    feat.isMobile = /iphone|ipod|ipad|android/g.test(ua); // currently this only influences volume change and its slider
    feat.isIPad = /ipad/g.test(ua);
    feat.isIPhoneOrIPod = !feat.isIPad && /iphone|ipod/g.test(ua);
    feat.isIOS = feat.isIPhoneOrIPod || feat.isIPad;
    feat.isChromeForAndroid = (/android \d+.+chrome/).test(ua);
    feat.isAndroid = (/android/).test(ua);

    if (feat.isAndroid) {
        var m = ua.match(/android\s+([\d\.]+)/);
        if (m && m.length > 0) {
            feat.androidVersion = parseInt(m[1], 10);
        }
    }

    // feat.hasTouchEvents = true; // TODO DEBUG ONLY!
    feat.hasTouchEvents = ('ontouchstart' in document.documentElement);

    feat.supportsVideoElement = false;
    feat.canPlayH264          = false;
    (function() {
        var el = document.createElement('video');
        feat.supportsVideoElement = !!el.play;

        if (feat.supportsVideoElement) {
            feat.canPlayH264 = !!( el.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, '') );

            feat.canPlayHLS  = !!( el.canPlayType('application/x-mpegurl'          ).replace(/^no$/, '') ||
                                   el.canPlayType('application/vnd.apple.mpegurl'  ).replace(/^no$/, '') );
                                   //(feat.androidVersion > 3 || (feat.isAndroid && !feat.androidVersion) )  ); // chrome/stockbrowser > 3 || firefox <- mas firefox n tem HLS
                                   //(feat.androidVersion > 3) ); // chrome/stockbrowser
        }
    })();



    feat.hasCORS = ('withCredentials' in new XMLHttpRequest());



    (function() {
        /*global ActiveXObject:false */
        // http://www.jquery4u.com/snippets/jquery-check-flash-enabled/
        // https://code.google.com/p/swfobject/source/browse/trunk/swfobject/src/swfobject.js line 48
        var hf = false;
        var flashVersion;
        try { // IE
            var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
            if (fo) { hf = true; }
            try {
                flashVersion = parseInt( new ActiveXObject('ShockwaveFlash.ShockwaveFlash').GetVariable('$version').split(' ')[1], 10);
            } catch (e) {}
        }
        catch (ex) {
            try {
                var plug = navigator.mimeTypes['application/x-shockwave-flash'];
                if (plug && plug.enabledPlugin) {
                    hf = true;
                }
                try {
                    flashVersion = parseInt( navigator.plugins["Shockwave Flash"].description.split(' ')[2] , 10);
                } catch (e) {}
            }
            catch (ex2) {}
        }
        feat.flashVersion = flashVersion;
        feat.hasFlash = hf && ( flashVersion >= 10 );
    })();



    feat.isOuter = function() {
        return (!!SAPO.Utility.IframeWrapper);
    };

    feat.inExternalIframe = function() {
        try {
            var win = window.parent;
            var doc = win.document;
            if (!doc) { return true; }
            return false;
        } catch (ex) {
            return true;
        }
    };

    feat.pageURI = function() {
        if (!this.isOuter()) {
            return window.parent.SAPO.Project.Video.Features.pageURI();
        }

        if (this.inExternalIframe()) {
            return document.referrer;
        }

        return window.location.href;
    };

    feat.pageProtocol = function() {
        return this.pageURI().substring(0, 5) === 'https' ? 'https:' : 'http:';
    };


    // console.log('FEATURES:', JSON.stringify(feat));


    SAPO.namespace('Project.Video');
    SAPO.Project.Video.Features = feat;

})(window);
